import React from 'react';
import { Link } from 'react-router-dom';

import { Card } from './Card';

export { Card };

export const FormCard: React.FC = ({children}) => <Card type="form">{children}</Card>;

interface BoundTitledTextCardProps
{
  title: string,
  description: string,
}
interface TitledTextCardProps extends BoundTitledTextCardProps
{
  type: string,
}
const TitledTextCard: React.FC<TitledTextCardProps> = ({type, title, description, children}) =>
  <Card type={['text', type].join(" ")}>
    <header></header>
    <section>
      <h2>{title}</h2>
      <p>{description}</p>
    </section>
  </Card>;
export const FeatureCard: React.FC<BoundTitledTextCardProps> = ({title, description}) => <TitledTextCard type="features" title={title} description={description}/>;
export const ToggleCard: React.FC<BoundTitledTextCardProps> = ({title, description}) => <TitledTextCard type="toggles" title={title} description={description}/>;
export const AudienceCard: React.FC<BoundTitledTextCardProps> = ({title, description}) => <TitledTextCard type="audience" title={title} description={description}/>;


interface NavigationCardProps
{
  to: string,
}
export const NavigationCard: React.FC<NavigationCardProps> = ({to, children}) => <Link to={to} className="card-link">{children}</Link>;